import classes from "./Pill_Widget.module.css";
import { AiOutlineInfoCircle } from "react-icons/ai"; // info icon


const Pill_Widget_2 = ({
  pillColour,
  textColor,
  text
}) => {
  
  // Set tooltip text based on the `text` prop
  let tooltipText;
  switch (text) {
    case "G2CC":
      tooltipText = "Gen 2 Cloud Controllers support Ajax, Dahua, AI Box & Hikvision";
      break;
    default:
      tooltipText = "";
  }



  return (
    <div
      className={`${classes["Pill_Widget"]}`}
        title={tooltipText}
      style={{
        backgroundColor: pillColour, 
        color: textColor,
        fontWeight: "600"
      }}
    >
      {text}
      {( text == "G2CC" && <AiOutlineInfoCircle
        style={{
          marginLeft: "6px",
          verticalAlign: "middle",
          fontSize: "14px",
          cursor: "pointer",
        }}
      />)}
    </div>
  );
};

export default Pill_Widget_2;
